module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mappage"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row main-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 cornered",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_c('div', {
    staticClass: "info-container"
  }, [_c('h4', {
    staticClass: "small-title",
    domProps: {
      "innerHTML": _vm._s(_vm.state.title)
    }
  }, [_c('hr')]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.state.subTitle))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "300px",
      "font-size": "15pt"
    }
  }, [_vm._v(_vm._s(_vm.state.pTextTop))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 map-container",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/imgs/home_foto5.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24f97dcd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/MapPage.vue
// module id = 144
// module chunks = 0